var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 24,
    viewBox: "0 0 38 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2882_259)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.983612 4C0.983612 1.79086 2.77447 0 4.98361 0H33.9836C36.1928 0 37.9836 1.79086 37.9836 4V20C37.9836 22.2091 36.1928 24 33.9836 24H4.98361C2.77447 24 0.983612 22.2091 0.983612 20V4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.983612 1.57377C0.983612 0.704601 1.68852 0 2.55808 0H36.4091C37.2786 0 37.9836 0.704601 37.9836 1.57377V22.4262C37.9836 23.2953 37.2786 24 36.4091 24H2.55808C1.68852 24 0.983612 23.2953 0.983612 22.4262V1.57377Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1964 0.0491803H1.77085C1.36324 0.0491803 1.03281 0.379462 1.03281 0.786885V23.2131C1.03281 23.6205 1.36324 23.9508 1.77085 23.9508H37.1964C37.604 23.9508 37.9344 23.6205 37.9344 23.2131V0.786885C37.9344 0.379462 37.604 0.0491803 37.1964 0.0491803Z",
    fill: "url(#paint0_linear_2882_259)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.51724 4.47169C1.51724 2.29877 3.27954 0.537268 5.45341 0.537268H24.3812C30.7147 0.537268 35.849 5.66929 35.849 12C35.849 18.3306 30.7147 23.4626 24.3812 23.4626H5.45341C3.27952 23.4626 1.51724 21.7011 1.51724 19.5282V4.47169Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6966 12.0146C12.6966 13.424 13.7959 14.5166 15.21 14.5166C15.61 14.5166 15.952 14.4372 16.3744 14.2373V13.1366C16.0032 13.5103 15.6743 13.6614 15.2531 13.6614C14.3175 13.6614 13.6536 12.9786 13.6536 12.0076C13.6536 11.0874 14.3391 10.3612 15.21 10.3612C15.6531 10.3612 15.9885 10.5199 16.3744 10.9003V9.79995C15.967 9.59195 15.6316 9.50559 15.2319 9.50559C13.8248 9.50559 12.6966 10.6206 12.6966 12.0146Z",
    fill: "#251F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3127 10.8503C10.3127 11.109 10.4766 11.2461 11.034 11.4537C12.0906 11.843 12.4038 12.1877 12.4038 12.9495C12.4038 13.8775 11.7263 14.5235 10.7612 14.5235C10.0546 14.5235 9.54067 14.2435 9.11253 13.611L9.7126 13.0293C9.92649 13.4457 10.2835 13.6687 10.7262 13.6687C11.1409 13.6687 11.4475 13.381 11.4475 12.9925C11.4475 12.7911 11.3544 12.618 11.169 12.4964C11.0755 12.4387 10.8905 12.3523 10.527 12.2233C9.65452 11.9073 9.35526 11.5692 9.35526 10.9084C9.35526 10.1237 9.99803 9.53465 10.8405 9.53465C11.3625 9.53465 11.8402 9.71435 12.2399 10.0664L11.7537 10.707C11.5117 10.434 11.2832 10.3185 11.0047 10.3185C10.6043 10.3185 10.3127 10.5482 10.3127 10.8503Z",
    fill: "#251F1F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.85041 9.61405H3.48678V14.4085H4.84311C5.56398 14.4085 6.0852 14.2373 6.54221 13.8551C7.08536 13.4023 7.40654 12.7199 7.40654 12.0146C7.40654 10.5997 6.35641 9.61405 4.85041 9.61405ZM5.93518 13.216C5.64321 13.4809 5.26432 13.5967 4.66425 13.5967H4.41497V10.4266H4.66425C5.26432 10.4266 5.62821 10.5343 5.93518 10.8143C6.25676 11.1021 6.44948 11.5482 6.44948 12.0076C6.44948 12.4677 6.25676 12.9282 5.93518 13.216Z",
    fill: "#251F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.76292 9.61405H7.83395V14.4085H8.76292V9.61405Z",
    fill: "#251F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.469 9.61405L23.7392 12.8341L25.0255 9.61405H26.0322L23.975 14.5317H23.4753L21.4547 9.61405H22.469Z",
    fill: "#251F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4522 14.4085H29.0865V13.5967H27.3806V12.3027H29.0233V11.4906H27.3806V10.4266H29.0865V9.61405H26.4522V14.4085Z",
    fill: "#251F1F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.0788 9.61405C32.15 9.61405 32.7646 10.1319 32.7646 11.0293C32.7646 11.7636 32.3789 12.2454 31.6792 12.3887L33.1781 14.4085H32.0361L30.7505 12.4824H30.6291V14.4085H29.7015V9.61405H31.0788ZM30.6291 11.8213H30.9011C31.494 11.8213 31.8084 11.5618 31.8084 11.08C31.8084 10.6133 31.494 10.3689 30.9152 10.3689H30.6291V11.8213Z",
    fill: "#251F1F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5048 9.86542C33.5048 9.78098 33.4468 9.73489 33.3456 9.73489H33.211V10.1578H33.311V9.99399L33.4283 10.1578H33.5509L33.4129 9.98355C33.4718 9.96728 33.5048 9.9239 33.5048 9.86542ZM33.3279 9.92311H33.311V9.81236H33.3291C33.3787 9.81236 33.4045 9.83056 33.4045 9.86697C33.4045 9.90415 33.3783 9.92311 33.3279 9.92311Z",
    fill: "#251F1F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9998 9.94556C32.9998 9.74068 33.162 9.57685 33.3655 9.57685C33.5641 9.57685 33.7272 9.74378 33.7272 9.94556C33.7272 10.1485 33.5641 10.3143 33.3655 10.3143C33.1636 10.3143 32.9998 10.1501 32.9998 9.94556ZM33.0725 9.94595C33.0725 10.1141 33.2035 10.2484 33.3639 10.2484C33.5241 10.2484 33.654 10.1125 33.654 9.94595C33.654 9.78096 33.5241 9.64308 33.3639 9.64308C33.2025 9.64308 33.0725 9.77786 33.0725 9.94595Z",
    fill: "#251F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1897 14.5542C17.7979 14.5542 16.6693 13.4178 16.6693 12.0165V12.0131C16.6693 11.3159 16.9497 10.6815 17.4032 10.2249C17.4032 10.2214 17.4068 10.2214 17.4068 10.218C17.4102 10.218 17.4102 10.2144 17.4137 10.2144C17.8672 9.75779 18.4973 9.47548 19.1897 9.47548H19.1932C20.5849 9.47548 21.7135 10.6118 21.7135 12.0131V12.0165C21.7135 12.7137 21.433 13.3447 20.9796 13.8048C20.9796 13.8083 20.976 13.8083 20.976 13.8118C20.9727 13.8118 20.9727 13.8152 20.9691 13.8152C20.5122 14.2718 19.8855 14.5542 19.1932 14.5542H19.1897Z",
    fill: "url(#paint1_linear_2882_259)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.98361 0.5H33.9836C35.9166 0.5 37.4836 2.067 37.4836 4V20C37.4836 21.933 35.9166 23.5 33.9836 23.5H4.98361C3.05062 23.5 1.48361 21.933 1.48361 20V4L1.48849 3.82031C1.58203 1.97083 3.11089 0.5 4.98361 0.5Z",
    stroke: "#6C757D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2882_259",
    x1: 12.6058,
    y1: -0.049387,
    x2: 27.0855,
    y2: 24.2522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E05026"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9A020"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2882_259",
    x1: 17.8695,
    y1: 9.47547,
    x2: 22.0378,
    y2: 12.9786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF3823"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489583,
    stopColor: "#F04D22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7911D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2882_259"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.983612 4C0.983612 1.79086 2.77447 0 4.98361 0H33.9836C36.1928 0 37.9836 1.79086 37.9836 4V20C37.9836 22.2091 36.1928 24 33.9836 24H4.98361C2.77447 24 0.983612 22.2091 0.983612 20V4Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover);
export default __webpack_public_path__ + "static/media/discover.9f66313e457c87e520c8282adfb7f7cc.svg";
export { ForwardRef as ReactComponent };